import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing) return <div className="centered">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  // The server enforces this too; hiding the route just avoids a pointless 403.
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;

  return children;
}
